import * as React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SxProps } from '@mui/system';
import { Dayjs } from 'dayjs';

interface Props {
  label: string | null
  date: Dayjs | null;
  setDate: (newDate: Dayjs | null) => void;
  error?: string;
  sx?: SxProps;
}

const CustomDatePicker: React.FC<Props> = ({ date, setDate, error, sx, label }) => {
  const handleDateChange = (newDate: Dayjs | null) => {
    setDate(newDate);
  };

  return (
        <DatePicker
            label={label}
            value={date}
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            slotProps={{
              textField: {
                variant: 'standard',
                error: !!error,
                helperText: error || '',
                sx,
              },
            }}
        />
  );
};

export default CustomDatePicker;
